class MenuOverlay extends HTMLElement {
  constructor() {
    super();
    this.closers = this.querySelectorAll('[data-menu-overlay-close]');

    this.closers.forEach((closer) => closer.addEventListener('click', this.close.bind(this)));
    this.addEventListener('keyup', this.onKeyUp.bind(this));

    this.querySelectorAll('a').forEach((el) => {
      el.addEventListener('click', () => this.close());
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.close();
  }

  open(opener) {
    this.opener = opener;
    this.setAttribute('aria-hidden', 'false');
    this.classList.add('is-open');
    document.body.classList.add('overflow-hidden-desktop');
    opener && opener.setAttribute('aria-expanded', 'true');
    trapFocus(this, this.querySelector('[data-menu-overlay-close]'));
  }

  close() {
    this.setAttribute('aria-hidden', 'true');
    this.classList.remove('is-open');
    document.body.classList.remove('overflow-hidden-desktop');
    removeTrapFocus(this.opener);
    if (this.opener) this.opener.setAttribute('aria-expanded', 'false');
  }
}

customElements.define('menu-overlay', MenuOverlay);

class MenuOverlayToggle extends HTMLElement {
  constructor() {
    super();
    this.panel = document.getElementById(this.getAttribute('aria-controls'));
    this.addEventListener('click', this.onClick.bind(this));
    this.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onClick() {
    if (!this.panel) return;
    this.panel.classList.contains('is-open') ? this.panel.close() : this.panel.open(this);
  }

  onKeyDown(event) {
    if (event.code.toUpperCase() === 'ENTER' || event.code.toUpperCase() === 'SPACE') {
      event.preventDefault();
      this.onClick();
    }
  }
}

customElements.define('menu-overlay-toggle', MenuOverlayToggle);
